<template>
  <v-app>
    <AppHeader v-bind="header" />

    <Main v-if="!submitted" />
    <ThankYou v-else />
  </v-app>
</template>

<script>
import Main from "@/views/Main.vue";
import AppHeader from "@/components/AppHeader.vue";
import ThankYou from "@/views/ThankYou.vue";
import { mapGetters } from "vuex";

export default {
  name: "App",

  components: { Main, ThankYou, AppHeader },

  // data: () => ({ submitted: true }),

  computed: {
    ...mapGetters("app", ["submitted"]),

    header() {
      if (this.submitted) {
        return {
          title: "Thank You",
          subTitle:
            "Thank you for your interest in Easypak. Your product sample order has been received and will be processed shortly. If you are interested in other Easypak products explore our product page."
        };
      }

      return {
        title: "Sample Request",
        subTitle:
          "Please fill out all required fields to proceed to the next step of the sample request form."
      };
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";
</style>
